export async function getUserData() {
  const response = await fetch(
    `${process.env.HOST}/umbraco/surface/User/GetUserModel`,
    {
      method: "GET",
      headers: {
        "AcceAccess-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
      }
    }
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
